export default __webpack_public_path__ + "assets/img/plants_2.jpg";